import React from 'react';
import { Tag, Tooltip } from 'antd';
import { FiMapPin } from 'react-icons/fi';
import PlatformIconRender from '../../Common/PlatformIconRender';
import './ProfileBasicComponent.styles.scss';

const ProfileBasicComponent = ({
  picture,
  firstname,
  lastname,
  gender,
  city_living,
  id,
  interests,
  twitter_account,
  youtube_account,
  instagram_account,
}) => {
  return (
    <div className="col-md-6 my-3 px-2">
      <div className="common_card p-3 profile_base_card h-100">
        <div className="row align-items-center">
          <div className="col-5">
            <div className="profile_base_card--pic text-center">
              <img src={picture}
                className="img-fluid"
                alt={firstname + ' ' +lastname} />
            </div>
          </div>
          <div className="col-7">
            <div className="profile_base_card_details">
              <h4 className="profile_base_card_details--name">{firstname + ' ' +lastname}</h4>
              <p className="profile_base_card_details--id"><span>ID:</span> {id}</p>
              <div className="profile_base_card_details--city"><FiMapPin/> {city_living || 'n/a'}</div>
              <div className="profile_base_card_details--interests">
                {interests && interests.length ?
                  <>
                    {interests.map((int, index)=>{
                      if (index <= 1) {
                        return <Tag key={int+index}>{int}</Tag>;
                      }
                    })}
                    {interests.length >= 2 ?
                      <Tooltip title={
                        <>Other Interests:
                          {interests.map((restInt, i)=>{
                            if (i >= 2) {
                              return <div key={i+restInt}>{restInt}</div>;
                            }
                          })}
                        </>
                      }>
                        <Tag>+{interests.length - 2}</Tag>
                      </Tooltip>:
                      null
                    }
                  </>:
                  <span className="no-interests">Interests: n/a</span>
                }
              </div>
              <div className="profile_base_card_details--platforms">
                <span className="profile_base_card_details--platforms--title">Available in: </span>
                {
                  youtube_account && youtube_account.enabled ?
                    <span><PlatformIconRender platform='youtube'
                      username={youtube_account.username}
                      size={20}/></span>:
                    null
                }
                {
                  twitter_account && twitter_account.enabled ?
                    <span><PlatformIconRender platform='twitter'
                      username={twitter_account.username}
                      size={20}/></span>:
                    null
                }
                {
                  instagram_account && instagram_account.enabled ?
                    <span><PlatformIconRender platform='instagram'
                      username={instagram_account.username}
                      size={20}/></span>:
                    null
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileBasicComponent;
